/// <reference path="../../typings/externals.d.ts" />
exports.mocha = require('../../test/mocha');
var expect = exports.mocha.chai.expect;
var spy = exports.mocha.sinon.spy;
var mock = exports.mocha.mock;
var rcsdk = exports.mocha.rcsdk;
describe('RCSDK.helpers.dictionaries.DeviceModel', function () {
    'use strict';
    var DeviceModel = rcsdk.getDeviceModelHelper();
    describe('getId', function () {
        it('provides artificial IDs', function () {
            expect(DeviceModel.getId({
                sku: '23',
                name: 'Polycom IP 321 Basic IP phone',
                deviceClass: 'Desk Phone'
            })).to.equal('23');
        });
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/helpers/DeviceModel-spec.ts
 ** module id = 70
 ** module chunks = 2
 **/